import React from 'react';
import {
  Box,
  Text,
  constants
} from '@match/react-component-library';
import { PageLayout } from '../../layouts';

const { SPACE, TYPOGRAPHY, FONT_WEIGHT } = constants;

class IneligiblePage extends React.Component<{}> {
  render() {
    return (
      <PageLayout>
        <Box
        textAlign="center"
        paddingBottom={SPACE.XXXLARGE}
        >
          <Text
            fontSize={TYPOGRAPHY.H4}
            fontWeight={FONT_WEIGHT.BOLD}
          >
          We are unable to process your gift card at this time.</Text>
        </Box>
        <Box
          textAlign="center"
          paddingBottom={SPACE.XXXLARGE}
        >
          Please call us Mon - Fri, 8am - 5pm CT.
        </Box>
        <Box
          textAlign="center"
        >
          1-800-92-MATCH (1-800-926-2824)
        </Box>
      </PageLayout>
    );
  }
}

export default IneligiblePage;
